import {BaseApi} from "@/http/api/BaseApi";
import {CategoryParamsType} from "@/types/categoryParamsType";
import {ICategory} from "@/interface/api/category";
import {CategoryApiResponse} from "@/types/api/category";

export default class CategoryServices extends BaseApi implements ICategory {

    getCategory = async ({slug, params}: CategoryParamsType): Promise<CategoryApiResponse> => {
        const url = this.urlBuilder(`categories/catalog/${slug}`, {...params});
        try {
            return await this.get(url);
        } catch (error) {
            throw error;
        }
    };

    getVariationTitle = async (id: number | string) => {
        return this.get(`variations/${id}`, {
            next: {
                revalidate: 60,
                tags: ["variation-title-" + id],
            }
        });
    }

    getAttributeTitle = async (id: number | string) => {
        return this.get(`attributes/${id}`, {
            next: {
                revalidate: 60 ,
                tags: ["attribute-title-" + id],
            }
        });
    }

    getVariationOptionTitle = async (id: number | string) => {
        return this.get(`variation-options/${id}`, {
            next: {
                revalidate: 60 ,
                tags: ["variation-title-" + id],
            }
        });
    }

    getAttributeOptionTitle = async (id: number | string) => {
        return this.get(`attribute-options/${id}`, {
            next: {
                revalidate: 60 ,
                tags: ["attribute-title-" + id],
            }
        });
    }

    variationsTitle = async (variationList: number[]) => {
        try {
            if (variationList?.length === 0) {
                return [];
            }
            const variationListIds = Object?.keys(variationList) ?? []
            const response: any[] = await Promise.all(variationListIds?.map(id => this.getVariationTitle(id)))
            return response?.flatMap((item: Record<string, string>) => item?.data)
        } catch (error) {
            await Promise.reject(error);
        }
    }

    attributesTitle = async (attributeList: number[]) => {
        try {
            if (attributeList?.length === 0) {
                return [];
            }
            const attributeIds = Object?.keys(attributeList) ?? []
            const response: any[] = await Promise.all(attributeIds?.map(id => this.getAttributeTitle(id)))
            return response?.flatMap((item: Record<string, string>) => item?.data)
        } catch (error) {
            await Promise.reject(error);
        }
    }


    variationOptionItem = async (variationIds: any, variationList: number[]) => {
        try {
            return await variationIds?.map((item: any) => {
                return {parent : item , children : variationList[item?.id]}
            })
        } catch (error) {
            await Promise.reject(error);
        }
    }

    attributeOptionItem = async (attributeIds: any, attributeList: number[]) => {
        try {
            return await attributeIds?.map((item: any) => {
                return {parent : item , children : attributeList[item?.id]}
            })
        } catch (error) {
            await Promise.reject(error);
        }
    }

    variationOptionsTitleIds = async (variationList: number[]) => {
        try {
            if (variationList) {
                const variationIds = await this.variationsTitle(variationList);
                return await this.variationOptionItem(variationIds, variationList)
            }
        } catch (error) {
            await Promise.reject(error);
        }
    }

    attributeOptionsTitleIds = async (attributeList: number[]) => {
        try {
            if (attributeList) {
                const attributeId = await this.attributesTitle(attributeList);
                return await this.attributeOptionItem(attributeId, attributeList)
            }
        } catch (error) {
            await Promise.reject(error);
        }
    }
}
